"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligibility = exports.claimReversal = exports.claim = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.claim = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'post',
    path: 'sink/erx/claim',
});
exports.claimReversal = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'post',
    path: 'sink/erx/reversal',
});
exports.eligibility = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: 'post',
    path: 'sink/erx/eligibility',
});



//////////////////
// WEBPACK FOOTER
// ./src/api/sink/sink-client.ts
// module id = 999
// module chunks = 0 1 2